var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"custom-text",attrs:{"outlined":"","value":_vm.itemValue,"label":_vm.label,"rules":_vm.rules},on:{"change":_vm.change,"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }